/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React from "react";
import Grid from "@mui/material/Grid";
import AlimonyPerson from "./Alimony/AlimonyPerson";
import _ from "lodash";
import useForm from "../../../hooks/useForm";
import ValidatorForm from "../../Validator/ValidatorForm";
import SubmitButton from "../../Button/SubmitButton";
import ValidatorSelect from "../../Validator/ValidatorSelect";
import { formValue } from "../../../services/formServiceFunctions";
import MenuItem from "@mui/material/MenuItem";
import { processCostSupportStyle } from "../processCostSupportStyle";
import { Box, SelectChangeEvent } from "@mui/material";
import { ProcessCostSupportFormProps } from "../../../types/ProcessCostSupport";

const Alimony = ({ pcs, onSubmit, isLoading }: ProcessCostSupportFormProps) => {
  const initialValues = {
    hasRelativesAlimonyClaims: pcs.hasRelativesAlimonyClaims,
    alimonyPersons: pcs.alimonyPersons,
  };

  const { values, handleChange, handleSubmit, touchedValues, errors, handleBlur } = useForm({
    initialValues,
    onSubmit,
    identifier: pcs,
  });

  const addAlimonyPerson = () => {
    const emptyPerson = {
      gender: "",
      givenName: "",
      familyName: "",
      livesWithPetitioner: false,
      address: {
        streetAddress: "",
        postalCode: "",
        addressLocality: "",
      },
      birthDate: "",
      relation: "",
      alimony: "",
      hasIncome: "",
      income: "",
    };

    const alimonyPersons = values.alimonyPersons || [];
    if (alimonyPersons.length >= 5) {
      return;
    }

    alimonyPersons.push(emptyPerson);

    handleChange({
      target: {
        type: "other",
        name: "alimonyPersons",
        value: alimonyPersons,
      },
    });
  };

  const handleMore = ({ target }: SelectChangeEvent) => {
    const { name, value } = target;
    if (value === "yes") {
      addAlimonyPerson();
    }
    if (value === "no") {
      const splitName = _.split(name, "-");
      const lastPart = splitName[splitName.length - 1];
      const key = parseInt(lastPart);

      handleChange({
        target: {
          type: "other",
          name: "alimonyPersons",
          value: _.slice(values.alimonyPersons, 0, key + 1),
        },
      });
    }
  };

  return (
    <>
      <Box sx={processCostSupportStyle.sectionHeadline}>Unterhalt zahlen</Box>
      <ValidatorForm onSubmit={handleSubmit}>
        <Grid container sx={processCostSupportStyle.grid}>
          <Grid sx={processCostSupportStyle.question} size={12}>
            Müssen Sie an jemanden Unterhalt zahlen, oder leben Kinder bei Ihnen, die Sie versorgen?
          </Grid>
          <Grid
            size={{
              xs: 12,
              md: 6,
              lg: 4
            }}>
            <ValidatorSelect
              label={"Unterhalt zahlen?"}
              name={"hasRelativesAlimonyClaims"}
              value={formValue(values, "hasRelativesAlimonyClaims")}
              onChange={handleChange}
              onBlur={handleBlur}
            >
              <MenuItem value={"no"}>Nein</MenuItem>
              <MenuItem value={"yes"}>Ja</MenuItem>
            </ValidatorSelect>
          </Grid>
          {formValue(values, "hasRelativesAlimonyClaims") === "yes" && (
            <>
              {_.map(values.alimonyPersons, (alimonyPerson, key) => (
                <React.Fragment key={key}>
                  <AlimonyPerson
                    path={`alimonyPersons[${key}]`}
                    person={alimonyPerson}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                  />
                  {parseInt(key) < 4 && (
                    <Grid
                      size={{
                        xs: 12,
                        md: 6,
                        lg: 4
                      }}>
                      <ValidatorSelect
                        label={"Weitere Person?"}
                        name={`hasMore-${key}`}
                        value={formValue(values, "alimonyPersons").length - 1 > parseInt(key) ? "yes" : "no"}
                        onChange={handleMore}
                        onBlur={handleBlur}
                      >
                        <MenuItem value={"no"}>Nein</MenuItem>
                        <MenuItem value={"yes"}>Ja</MenuItem>
                      </ValidatorSelect>
                    </Grid>
                  )}
                </React.Fragment>
              ))}
            </>
          )}
          <Grid size={12}>
            <SubmitButton
              error={_.keys(errors).length > 0}
              isLoading={isLoading}
              disabled={_.keys(touchedValues).length === 0}
              variant={"contained"}
              type={"submit"}
            >
              Änderungen speichern
            </SubmitButton>
          </Grid>
        </Grid>
      </ValidatorForm>
    </>
  );
};

export default Alimony;
